// Listado oficial de las 14 zonas de Málaga Responde (11 distritos y 3 barriadas)
export const ZONAS_MALAGA = [
    'Distrito 1 — Centro',
    'Distrito 2 — Este',
    'Distrito 3 — Ciudad Jardín',
    'Distrito 4 — Bailén-Miraflores',
    'Distrito 5 — Palma-Palmilla',
    'Distrito 6 — Cruz de Humilladero',
    'Distrito 7 — Carretera de Cádiz',
    'Distrito 8 — Churriana',
    'Distrito 9 — Campanillas',
    'Distrito 10 — Puerto de la Torre',
    'Distrito 11 — Teatinos-Universidad',
    'Barriada de Santa Águeda',
    'Barriada de Santa Cristina',
    'Barriada de La Isla',
];

export const ZONAS_MALAGA_OPTIONS = [
    { value: '', label: '-- Seleccionar zona --' },
    ...ZONAS_MALAGA.map((z) => ({ value: z, label: z })),
];

// Normaliza valores heredados o importados (p.ej. "Centro" -> "Distrito 1 — Centro")
export function normalizarZonaMalaga(raw) {
    if (!raw) return '';
    const trimmed = String(raw).trim();
    if (!trimmed) return '';

    // Coincidencia exacta
    if (ZONAS_MALAGA.includes(trimmed)) return trimmed;

    const clean = (s) =>
        String(s)
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .replace(/[—–-]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();

    const target = clean(trimmed);

    for (const zona of ZONAS_MALAGA) {
        const cz = clean(zona);
        if (cz === target) return zona;
        // Coincidencia por nombre corto de distrito o barriada (ej. "Centro", "Churriana", "Santa Agueda")
        const partes = zona.split('—').map((p) => clean(p));
        if (partes.some((p) => p === target)) return zona;
        if (cz.endsWith(target) && target.length >= 4) return zona;
    }

    return trimmed;
}
